import { GridColumnMenuProps } from "@mui/x-data-grid";
import { FieldValues, useForm } from "react-hook-form";
import { ItecColFilters } from "../types";
import { Box, Button, IconButton, Stack, Tooltip } from "@mui/material";
import { FilterAltOff, Close, Search } from "@mui/icons-material";
import { useState } from "react";
import { Select } from "src/lib/itaptec/components_forms/src";

type UseFilterProps<TFilter extends FieldValues> = {
  filters: ItecColFilters<TFilter> | undefined;
};

export type UseFilter<TFilter extends FieldValues> = {
  columnMenuComponent: React.JSXElementConstructor<GridColumnMenuProps>;
  filter: TFilter | undefined;
};

export function useFilter<TFilter extends FieldValues>(
  props: UseFilterProps<TFilter>
) {
  const { filters } = props;

  const [filter, setFilter] = useState<TFilter>();

  const form = useForm<TFilter>({
    mode: "onChange",
  });

  if (!filters) {
    return undefined;
  }

  // const onFilterChange = () => {
  //   handleSubmit(setFilter)();
  // };

  return {
    // columnMenuComponent: (props) => {
    //   const {
    //     colDef: { field },
    //   } = props;

    //   // TODO: make field of type union of possible fields

    //   const menuParams = filters?.[field];

    //   if (!menuParams) return undefined;

    //   return (
    //     <Stack
    //       minWidth={300}
    //       p={2}
    //       spacing={2}
    //       direction="row"
    //       display="flex"
    //       justifyContent="space-between"
    //       alignItems="center"
    //     >
    //       <Box sx={{ width: "100%" }}>
    //         {menuParams.type === "select" && (
    //           <Select
    //             name={menuParams.name}
    //             control={control}
    //             getOptions={menuParams.getOptions}
    //             size="small"
    //             fullWidth
    //           />
    //         )}
    //       </Box>
    //       <Box display="flex">
    //         <Tooltip title="Limpiar filtro">
    //           <IconButton
    //             onClick={() => {
    //               resetField(menuParams.name);
    //               // onFilterChange(); // search on filter reset
    //             }}
    //           >
    //             <FilterAltOff />
    //           </IconButton>
    //         </Tooltip>
    //         <Tooltip title="Cerrar filtro">
    //           <IconButton>
    //             <Close />
    //           </IconButton>
    //         </Tooltip>
    //       </Box>
    //     </Stack>
    //   );
    // },
    form,
    filter,
  };
}

{
  /* <Button
              type="submit"
              onClick={onFilterChange}
              startIcon={<Search />}
            >
              Buscar
            </Button> */
}
